import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class NavigationService {

	public navigationChange: EventEmitter<any[]> = new EventEmitter();
	private navigation: any[] = null;

	constructor() { }

	public getNavigation(): any[] {
		return this.navigation;
	}

	public setNavigation(navigation: any[]) {
		this.navigationChange.emit(navigation);
		this.navigation = navigation;
	}

	public hasNavigationContent(): boolean {
		return this.navigation && this.navigation.length > 0;
	}
}
